module.exports = __webpack_public_path__ + "static/mask-DND3_FnP-1f207ed3229c7f80084072a224895b0c.jpg";